// Mobile sticky add-to-cart: reveals itself once the main add-to-cart button scrolls out of view.
// It lives inside the product-form partial, so variant changes re-render it with fresh price/state.
class StickyAtc extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = document.querySelector('[data-main-atc]');
    this.#hide();
    if (!target) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (passed) this.#show();
      else this.#hide();
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #show() {
    this.setAttribute('data-visible', '');
    this.removeAttribute('inert');
    this.removeAttribute('aria-hidden');
  }

  #hide() {
    this.removeAttribute('data-visible');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', StickyAtc);
}
